var baseStyle = {
  bg: 'grey.950',
  color: 'white',
  fontWeight: 'bold'
};
function variantSolid() {
  return {
    borderRadius: 0
  };
}
function variantPill() {
  return {
    borderRadius: 0,
    px: 3,
    fontWeight: 'normal'
  };
}
var variants = {
  solid: variantSolid,
  pill: variantPill
};
var defaultProps = {
  variant: 'solid'
};
export default {
  baseStyle,
  variants,
  defaultProps
};